// test2283
(2283 && 0);
